module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
        active: _vm.open
      },
      'ge-menu-toggle'
    ]
  }, [_c('a', {
    class: {
      active: _vm.open
    },
    attrs: {
      "href": _vm.link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "plain",
    on: {
      "click": _vm.toggle
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-1c1664f0"}!./scripts/ge-menu-toggle/ge-menu-toggle.html
// module id = 342
// module chunks = 1